import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Block({ icon, content, rightIcon }) {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          marginLeft: "1rem",
          width:"100%"
        }}
      >
        <div style={{ width: "20px" }}>
          <span >
            <FontAwesomeIcon icon={icon} />
          </span>
        </div>
        <p style={{ fontWeight: 500, maxWidth: "80%" }}>{content}</p>
      </div>
      <p
        style={{
          position: "relative",
          right: "15px",
        }}
      >
        <FontAwesomeIcon
          icon={rightIcon}
          style={{
            fontSize: "16px",
          }}
        />
      </p>
    </>
  );
}

export default Block;
